export default "__VITE_ASSET__BM208eHg__"